(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cf-diy-charm-builder"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-mix-builder]').forEach((root) => {
    const catalog=JSON.parse(root.querySelector('[data-cf-catalog]').textContent);
    const productMap=new Map([...catalog.bags,...catalog.charms].map((p)=>[p.id,p]));
    const state={mode:'charms',bag:null,items:new Map()};
    let bagFilter='all',charmFilter='all',characterFilter='all',searchTerm='';
    let optionContext=null,optionVariantId=null,toastTimer=null;

    const section=root.closest('.cf-mix');
    const bagPicker=root.querySelector('[data-bag-picker]');
    const bagRail=root.querySelector('[data-bag-rail]');
    const charmGrid=root.querySelector('[data-charm-grid]');
    const picked=root.querySelector('[data-picked]');
    const empty=root.querySelector('[data-empty]');
    const bagSummary=root.querySelector('[data-bag-summary]');
    const totalEl=root.querySelector('[data-total]');
    const cartBtn=root.querySelector('[data-cart]');
    const itemCount=root.querySelector('[data-item-count]');
    const summaryTitle=root.querySelector('[data-summary-title]');
    const upsell=root.querySelector('[data-switch-full]');
    const inlineUpsell=root.querySelector('[data-switch-full-inline]');
    const search=root.querySelector('[data-search]');
    const searchWrap=search.closest('.cf-mix__search');
    const searchToggle=root.querySelector('[data-search-toggle]');
    const toast=root.querySelector('[data-toast]');
    const selectedLabel=root.querySelector('[data-selected-label]');
    const selectedSub=root.querySelector('[data-selected-sub]');
    const reviewOpen=root.querySelector('[data-review-open]');
    const mobileReview=root.querySelector('[data-mobile-review]');
    const mobileCart=root.querySelector('[data-mobile-cart]');
    const mobileBar=root.querySelector('[data-mobile-bar]');
    const mobileCount=root.querySelector('[data-mobile-count]');
    const mobileTotal=root.querySelector('[data-mobile-total]');
    const optionsDialog=root.querySelector('[data-options-dialog]');
    const reviewDialog=root.querySelector('[data-review-dialog]');
    const reviewItems=root.querySelector('[data-review-items]');
    const reviewBag=root.querySelector('[data-review-bag]');
    const reviewTotal=root.querySelector('[data-review-total]');
    const reviewSavings=root.querySelector('[data-review-savings]');
    const reviewCart=root.querySelector('[data-review-cart]');
    const savingsEl=root.querySelector('[data-savings]');
    const savingsAmount=root.querySelector('[data-savings-amount]');

    const money=(value)=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:'USD'}).format(value/100);
    const cents=(price)=>Math.round(Number(price||0)*100);
    const numericId=(gid)=>Number(String(gid).split('/').pop());
    const bagVariants=(product)=>{
      const plain=product.variants.filter((v)=>/without charm/i.test(v.title));
      return plain.length?plain:product.variants;
    };
    const imageFor=(product,variant)=>(variant&&variant.image)?variant.image:product.image;
    const liveProductLoads=new Map();
    const refreshLiveProduct=async(product)=>{
      if(!product||!product.handle)return product;
      if(liveProductLoads.has(product.handle))return liveProductLoads.get(product.handle);
      const request=(async()=>{
        try{
          const rootPath=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
          const response=await fetch(rootPath+'products/'+encodeURIComponent(product.handle)+'.js',{headers:{'Accept':'application/json'}});
          if(!response.ok)return product;
          const live=await response.json();
          const byId=new Map((live.variants||[]).map((variant)=>[String(variant.id),variant]));
          (product.variants||[]).forEach((variant)=>{
            const current=byId.get(String(numericId(variant.id)));
            if(!current)return;
            const featured=current.featured_image;
            const src=featured&&(featured.src||featured.url);
            if(src)variant.image=src;
            if(typeof current.price==='number')variant.price=(current.price/100).toFixed(2);
          });
          const featured=live.featured_image;
          if(typeof featured==='string'&&featured)product.image=featured;
          else if(featured&&(featured.src||featured.url))product.image=featured.src||featured.url;
        }catch(error){}
        return product;
      })();
      liveProductLoads.set(product.handle,request);
      return request;
    };

    const selectedEntries=()=>Array.from(state.items.values());
    const charmQuantity=()=>selectedEntries().reduce((sum,item)=>sum+item.qty,0);
    const charmSubtotalCents=()=>selectedEntries().reduce((sum,item)=>sum+cents(item.variant.price)*item.qty,0);
    const discountRateForQty=(qty)=>qty>=4?0.15:qty>=3?0.10:qty>=2?0.05:0;
    const charmDiscountCents=()=>{
      const subtotal=charmSubtotalCents();
      return Math.round(subtotal*discountRateForQty(charmQuantity()));
    };
    const totalCents=()=>{
      let total=charmSubtotalCents()-charmDiscountCents();
      if(state.mode==='full'&&state.bag)total+=cents(state.bag.variant.price);
      return total;
    };
    const readyToCart=()=>charmQuantity()>0&&(state.mode==='charms'||!!state.bag);

    const notify=(message)=>{
      clearTimeout(toastTimer);
      toast.textContent=message;
      toast.classList.add('is-visible');
      toastTimer=setTimeout(()=>toast.classList.remove('is-visible'),1400);
    };

    const filteredBags=()=>catalog.bags.filter((p)=>bagFilter==='all'||p.category===bagFilter);
    const filteredCharms=()=>catalog.charms.filter((p)=>{
      if(charmFilter!=='all'&&p.category!==charmFilter)return false;
      if(charmFilter==='character'&&characterFilter!=='all'&&p.subcategory!==characterFilter)return false;
      if(searchTerm&&!p.title.toLowerCase().includes(searchTerm))return false;
      return true;
    });

    const selectedQtyForProduct=(product)=>{
      return product.variants.reduce((sum,v)=>sum+(state.items.get(v.id)?.qty||0),0);
    };

    const selectedVariantForSingle=(product)=>{
      const variants=product.variants;
      return variants.length===1?variants[0]:null;
    };

    const bagCard=(product)=>{
      const variants=bagVariants(product);
      const active=state.bag&&state.bag.product.id===product.id?state.bag.variant:variants[0];
      const selected=!!(state.bag&&state.bag.product.id===product.id);
      return '<article class="cf-mix__bag-card'+(selected?' is-selected':'')+'" data-bag-card="'+product.id+'" tabindex="0" role="button">'+
        '<div class="cf-mix__media"><img src="'+imageFor(product,active)+'" alt="'+product.title.replace(/"/g,'&quot;')+'">'+
        (variants.length>1?'<span class="cf-mix__options-badge">OPTIONS</span>':'<span class="cf-mix__add-badge">'+(selected?'✓':'+')+'</span>')+
        '</div>'+
        '<div class="cf-mix__bag-info"><strong>'+product.title+'</strong><span>'+money(cents(active.price))+'</span></div>'+
      '</article>';
    };

    const charmCard=(product)=>{
      const variants=product.variants;
      const quantity=selectedQtyForProduct(product);
      const single=selectedVariantForSingle(product);
      const selected=quantity>0;
      let action='';
      if(single&&selected){
        const item=state.items.get(single.id);
        action='<div class="cf-mix__card-qty"><button type="button" data-card-minus="'+single.id+'" aria-label="Decrease quantity">−</button><span>'+item.qty+'</span><button type="button" data-card-plus="'+single.id+'" aria-label="Increase quantity">+</button></div>';
      }else if(variants.length>1){
        action='<span class="cf-mix__options-badge">OPTIONS'+(quantity?' · '+quantity:'')+'</span>';
      }else{
        action='<span class="cf-mix__add-badge">+</span>';
      }
      const preview=single||variants[0];
      return '<article class="cf-mix__card'+(selected?' is-selected':'')+'" data-charm-card="'+product.id+'" tabindex="0" role="button">'+
        '<div class="cf-mix__media"><img loading="lazy" src="'+imageFor(product,preview)+'" alt="'+product.title.replace(/"/g,'&quot;')+'">'+action+'</div>'+
        '<div class="cf-mix__card-info"><strong>'+product.title+'</strong><span>'+(variants.length>1?'From ':'')+money(cents(preview.price))+'</span></div>'+
      '</article>';
    };

    const renderCatalog=()=>{
      const bags=filteredBags();
      bagRail.innerHTML=bags.map(bagCard).join('');
      root.querySelector('[data-bag-count]').textContent=bags.length+' bags';

      const charms=filteredCharms();
      charmGrid.innerHTML=charms.map(charmCard).join('');
      root.querySelector('[data-charm-count]').textContent=charms.length+' charms';
      root.querySelector('[data-character-filters]').hidden=charmFilter!=='character';
    };

    const quantityMarkup=(key,qty,prefix='')=>{
      return '<div class="cf-mix__qty"><button type="button" data-'+prefix+'minus="'+key+'">−</button><span>'+qty+'</span><button type="button" data-'+prefix+'plus="'+key+'">+</button></div>';
    };

    const renderSummary=()=>{
      const entries=selectedEntries();
      const qty=charmQuantity();
      const includeBag=state.mode==='full'&&state.bag;
      const total=totalCents();
      const discount=charmDiscountCents();
      const rate=discountRateForQty(qty);
      const ratePercent=Math.round(rate*100);

      selectedLabel.textContent=rate?qty+' CHARMS · '+ratePercent+'% OFF':qty+' CHARM'+(qty===1?'':'S')+' SELECTED';
      if(qty===1)selectedSub.textContent='Add 1 more charm to unlock 5% off.';
      else if(qty===2)selectedSub.textContent='5% OFF unlocked · Add 1 more for 10% off.';
      else if(qty===3)selectedSub.textContent='10% OFF unlocked · Add 1 more for 15% off.';
      else if(qty>=4)selectedSub.textContent='15% OFF unlocked · Best value.';
      else selectedSub.textContent='Add anything you love — no minimum.';
      reviewOpen.disabled=qty===0;
      reviewOpen.closest('.cf-mix__selection-strip').hidden=qty===0;
      mobileReview.disabled=qty===0;
      mobileBar.hidden=qty===0;
      mobileCount.textContent=qty+' charm'+(qty===1?'':'s')+(rate?' · '+ratePercent+'% off':'');
      mobileTotal.textContent=money(total);
      totalEl.textContent=money(total);
      savingsEl.hidden=discount<=0;
      savingsAmount.textContent='−'+money(discount);
      reviewSavings.hidden=discount<=0;
      reviewSavings.textContent=discount>0?'You save '+money(discount)+' on charms':'';
      itemCount.textContent=(qty+(includeBag?1:0))+' items';
      summaryTitle.textContent=state.mode==='full'?'Bag + Charms':'Charms Only';
      empty.hidden=entries.length>0;
      upsell.hidden=state.mode==='full'||qty<2;
      inlineUpsell.hidden=state.mode==='full'||qty<2;

      if(includeBag){
        const b=state.bag;
        bagSummary.hidden=false;
        bagSummary.innerHTML='<img src="'+imageFor(b.product,b.variant)+'" alt="">'+
          '<div><strong>'+b.product.title+'</strong><span>'+b.variant.title+' · '+money(cents(b.variant.price))+'</span></div>'+
          '<button type="button" data-remove-bag>Remove</button>';
      }else{
        bagSummary.hidden=true;
        bagSummary.innerHTML='';
      }

      picked.innerHTML=entries.map((item)=>{
        return '<article class="cf-mix__picked-item">'+
          '<img src="'+imageFor(item.product,item.variant)+'" alt="">'+
          '<div class="cf-mix__picked-copy"><strong>'+item.product.title+'</strong><span>'+item.variant.title+' · '+money(cents(item.variant.price))+'</span>'+
          '<button type="button" class="cf-mix__remove" data-remove="'+item.variant.id+'">Remove</button></div>'+
          quantityMarkup(item.variant.id,item.qty)+
        '</article>';
      }).join('');

      const ready=readyToCart();
      cartBtn.disabled=!ready;
      mobileCart.disabled=!ready;
      reviewCart.disabled=!ready;
      if(state.mode==='full'){
        cartBtn.textContent=ready?'Add full mix to cart':'Choose bag + charms';
        mobileCart.textContent=ready?'Add full mix':'Choose bag + charms';
        reviewCart.textContent=ready?'Add full mix to cart':'Choose bag + charms';
      }else{
        cartBtn.textContent=ready?'Add charms to cart':'Choose your charms';
        mobileCart.textContent=ready?'Add charms':'Choose charms';
        reviewCart.textContent=ready?'Add charms to cart':'Choose your charms';
      }
    };

    const renderReview=()=>{
      const entries=selectedEntries();
      if(state.mode==='full'&&state.bag){
        const b=state.bag;
        reviewBag.innerHTML='<article class="cf-mix__review-item"><img src="'+imageFor(b.product,b.variant)+'" alt=""><div><strong>'+b.product.title+'</strong><span>'+b.variant.title+' · '+money(cents(b.variant.price))+'</span></div><button type="button" class="cf-mix__remove" data-remove-bag>Remove</button></article>';
      }else{
        reviewBag.innerHTML='';
      }
      reviewItems.innerHTML=entries.map((item)=>{
        return '<article class="cf-mix__review-item"><img src="'+imageFor(item.product,item.variant)+'" alt=""><div><strong>'+item.product.title+'</strong><span>'+item.variant.title+' · '+money(cents(item.variant.price))+'</span><button type="button" class="cf-mix__remove" data-review-remove="'+item.variant.id+'">Remove</button></div>'+quantityMarkup(item.variant.id,item.qty,'review-')+'</article>';
      }).join('');
      reviewTotal.textContent=money(totalCents());
      renderSummary();
    };

    const renderAll=()=>{
      bagPicker.hidden=state.mode!=='full';
      root.querySelector('[data-charm-step]').textContent=state.mode==='full'?'STEP 2':'BUILD YOUR MIX';
      section.querySelectorAll('[data-mode]').forEach((btn)=>btn.classList.toggle('is-active',btn.dataset.mode===state.mode));
      renderCatalog();
      renderSummary();
      if(reviewDialog.open)renderReview();
    };

    const addVariant=(product,variant)=>{
      const existing=state.items.get(variant.id);
      if(existing)existing.qty+=1;
      else state.items.set(variant.id,{product,variant,qty:1});
      renderAll();
      notify('Added to your mix');
    };

    const changeQty=(key,delta)=>{
      const item=state.items.get(key);
      if(!item)return;
      item.qty+=delta;
      if(item.qty<=0)state.items.delete(key);
      renderAll();
      if(reviewDialog.open)renderReview();
    };

    const removeVariant=(key)=>{
      state.items.delete(key);
      renderAll();
      if(reviewDialog.open)renderReview();
    };

    const chooseBagVariant=(product,variant)=>{
      state.bag={product,variant};
      renderAll();
      notify('Bag selected');
    };

    const switchMode=(mode)=>{
      state.mode=mode;
      renderAll();
      if(mode==='full')setTimeout(()=>bagPicker.scrollIntoView({behavior:'smooth',block:'start'}),50);
    };

    const openOptions=async(product,kind)=>{
      const variants=kind==='bag'?bagVariants(product):product.variants;
      optionContext={product,kind,variants};
      const current=(kind==='bag'&&state.bag&&state.bag.product.id===product.id)?state.bag.variant:variants[0];
      optionVariantId=current.id;
      root.querySelector('[data-options-kicker]').textContent=kind==='bag'?'CHOOSE BAG OPTION':'CHOOSE OPTIONS';
      root.querySelector('[data-options-title]').textContent=product.title;
      const renderOptions=()=>{
        const variant=variants.find((v)=>v.id===optionVariantId)||variants[0];
        root.querySelector('[data-options-image]').src=imageFor(product,variant);
        root.querySelector('[data-options-image]').alt=product.title;
        root.querySelector('[data-options-price]').textContent=money(cents(variant.price));
        root.querySelector('[data-option-list]').innerHTML=variants.map((v)=>{
          const item=state.items.get(v.id);
          const selectedBag=kind==='bag'&&state.bag&&state.bag.variant.id===v.id;
          return '<button type="button" class="cf-mix__option'+(v.id===optionVariantId?' is-active':'')+'" data-option-variant="'+v.id+'"><span>'+v.title+'</span><strong>'+(item?item.qty+' selected':selectedBag?'Selected':money(cents(v.price)))+'</strong></button>';
        }).join('');
        root.querySelector('[data-options-add]').textContent=kind==='bag'?(state.bag&&state.bag.variant.id===variant.id?'Selected · Done':'Use this bag'):'Add to my mix';
      };
      optionsDialog._render=renderOptions;
      renderOptions();
      optionsDialog.showModal();
      await refreshLiveProduct(product);
      if(optionContext&&optionContext.product.id===product.id){
        renderOptions();
        renderCatalog();
      }
    };

    const closeDialog=(dialog)=>{
      if(dialog.open)dialog.close();
    };

    const openReview=()=>{
      renderReview();
      reviewDialog.showModal();
    };

    section.querySelector('[data-mode-tabs]').addEventListener('click',(event)=>{
      const btn=event.target.closest('[data-mode]');
      if(btn)switchMode(btn.dataset.mode);
    });
    upsell.addEventListener('click',()=>switchMode('full'));
    inlineUpsell.addEventListener('click',()=>switchMode('full'));

    root.querySelector('[data-bag-filters]').addEventListener('click',(event)=>{
      const btn=event.target.closest('[data-bag-filter]');
      if(!btn)return;
      bagFilter=btn.dataset.bagFilter;
      root.querySelectorAll('[data-bag-filter]').forEach((b)=>b.classList.toggle('is-active',b===btn));
      renderCatalog();
    });

    root.querySelector('[data-charm-filters]').addEventListener('click',(event)=>{
      const btn=event.target.closest('[data-charm-filter]');
      if(!btn)return;
      charmFilter=btn.dataset.charmFilter;
      root.querySelectorAll('[data-charm-filter]').forEach((b)=>b.classList.toggle('is-active',b===btn));
      renderCatalog();
    });

    root.querySelector('[data-character-filters]').addEventListener('click',(event)=>{
      const btn=event.target.closest('[data-character-filter]');
      if(!btn)return;
      characterFilter=btn.dataset.characterFilter;
      root.querySelectorAll('[data-character-filter]').forEach((b)=>b.classList.toggle('is-active',b===btn));
      renderCatalog();
    });

    search.addEventListener('input',()=>{
      searchTerm=search.value.trim().toLowerCase();
      renderCatalog();
    });
    searchToggle.addEventListener('click',()=>{
      searchWrap.classList.toggle('is-open');
      if(searchWrap.classList.contains('is-open'))setTimeout(()=>search.focus(),30);
    });

    reviewOpen.addEventListener('click',openReview);
    mobileReview.addEventListener('click',openReview);
    root.querySelector('[data-review-close]').addEventListener('click',()=>closeDialog(reviewDialog));
    root.querySelector('[data-options-close]').addEventListener('click',()=>closeDialog(optionsDialog));

    root.querySelector('[data-option-list]').addEventListener('click',(event)=>{
      const btn=event.target.closest('[data-option-variant]');
      if(!btn)return;
      optionVariantId=btn.dataset.optionVariant;
      if(optionsDialog._render)optionsDialog._render();
    });

    root.querySelector('[data-options-add]').addEventListener('click',()=>{
      if(!optionContext)return;
      const variant=optionContext.variants.find((v)=>v.id===optionVariantId)||optionContext.variants[0];
      if(optionContext.kind==='bag'){
        chooseBagVariant(optionContext.product,variant);
        closeDialog(optionsDialog);
      }else{
        addVariant(optionContext.product,variant);
        if(optionsDialog._render)optionsDialog._render();
      }
    });

    const actionHandler=(event)=>{
      const cardMinus=event.target.closest('[data-card-minus]');
      if(cardMinus){changeQty(cardMinus.dataset.cardMinus,-1);return true;}
      const cardPlus=event.target.closest('[data-card-plus]');
      if(cardPlus){changeQty(cardPlus.dataset.cardPlus,1);return true;}
      const reviewMinus=event.target.closest('[data-review-minus]');
      if(reviewMinus){changeQty(reviewMinus.dataset.reviewMinus,-1);return true;}
      const reviewPlus=event.target.closest('[data-review-plus]');
      if(reviewPlus){changeQty(reviewPlus.dataset.reviewPlus,1);return true;}
      const minus=event.target.closest('[data-minus]');
      if(minus){changeQty(minus.dataset.minus,-1);return true;}
      const plus=event.target.closest('[data-plus]');
      if(plus){changeQty(plus.dataset.plus,1);return true;}
      const reviewRemove=event.target.closest('[data-review-remove]');
      if(reviewRemove){removeVariant(reviewRemove.dataset.reviewRemove);return true;}
      const remove=event.target.closest('[data-remove]');
      if(remove){removeVariant(remove.dataset.remove);return true;}
      const removeBag=event.target.closest('[data-remove-bag]');
      if(removeBag){state.bag=null;renderAll();if(reviewDialog.open)renderReview();return true;}
      return false;
    };

    root.addEventListener('click',(event)=>{
      if(actionHandler(event))return;

      const bagCardEl=event.target.closest('[data-bag-card]');
      if(bagCardEl){
        const product=productMap.get(bagCardEl.dataset.bagCard);
        if(!product)return;
        const variants=bagVariants(product);
        if(variants.length>1)openOptions(product,'bag');
        else chooseBagVariant(product,variants[0]);
        return;
      }

      const charmCardEl=event.target.closest('[data-charm-card]');
      if(charmCardEl){
        const product=productMap.get(charmCardEl.dataset.charmCard);
        if(!product)return;
        if(product.variants.length>1)openOptions(product,'charm');
        else addVariant(product,product.variants[0]);
      }
    });

    reviewDialog.addEventListener('click',(event)=>{
      if(event.target===reviewDialog)closeDialog(reviewDialog);
    });
    optionsDialog.addEventListener('click',(event)=>{
      if(event.target===optionsDialog)closeDialog(optionsDialog);
    });

    root.addEventListener('keydown',(event)=>{
      if(event.key!=='Enter'&&event.key!==' ')return;
      const bag=event.target.closest('[data-bag-card]');
      const charm=event.target.closest('[data-charm-card]');
      if(!bag&&!charm)return;
      event.preventDefault();
      if(bag){
        const product=productMap.get(bag.dataset.bagCard);
        const variants=bagVariants(product);
        if(variants.length>1)openOptions(product,'bag');
        else chooseBagVariant(product,variants[0]);
      }
      if(charm){
        const product=productMap.get(charm.dataset.charmCard);
        if(product.variants.length>1)openOptions(product,'charm');
        else addVariant(product,product.variants[0]);
      }
    });

    const addToCart=async()=>{
      const entries=selectedEntries();
      if(!readyToCart())return;
      [cartBtn,mobileCart,reviewCart].forEach((btn)=>{btn.disabled=true;btn.dataset.oldText=btn.textContent;btn.textContent='Adding...';});
      const items=[];
      if(state.mode==='full'&&state.bag){
        items.push({id:numericId(state.bag.variant.id),quantity:1,properties:{'_CarryFizz Mix':'Bag + Charms'}});
      }
      entries.forEach((item)=>items.push({id:numericId(item.variant.id),quantity:item.qty}));
      try{
        const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        if(!response.ok)throw new Error('Cart add failed');
        window.location.href='/cart';
      }catch(error){
        renderAll();
        notify('Please try again');
      }
    };

    cartBtn.addEventListener('click',addToCart);
    mobileCart.addEventListener('click',addToCart);
    reviewCart.addEventListener('click',addToCart);

    renderAll();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-home-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const hero = document.currentScript?.closest('.shopify-section')?.querySelector('.cf-brand-hero--video');
    if (!hero) return;

    const copy = hero.querySelector('.cf-brand-hero__copy');
    if (!copy) return;

    let ticking = false;

    const updateCopyPosition = () => {
      ticking = false;

      if (window.innerWidth < 750) {
        copy.style.removeProperty('top');
        copy.style.removeProperty('bottom');
        copy.style.removeProperty('transform');
        return;
      }

      const rect = hero.getBoundingClientRect();
      const heroHeight = hero.offsetHeight;
      const copyHeight = copy.offsetHeight;
      const viewportCenter = window.innerHeight / 2;

      const edgeGap = 28;
      const minY = (copyHeight / 2) + edgeGap;
      const maxY = heroHeight - (copyHeight / 2) - edgeGap;
      const desiredY = viewportCenter - rect.top;
      const y = Math.max(minY, Math.min(maxY, desiredY));

      copy.style.top = y + 'px';
      copy.style.bottom = 'auto';
      copy.style.transform = 'translate(-50%, -50%)';
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateCopyPosition);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    requestUpdate();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
